module.exports = __webpack_public_path__ + "img/lmo-logo.95a1c758.png";